<template>
    <div>
        <el-dialog top="5%" title="新增" v-model="editFormVisible" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="项目模板名称" prop="FName">
                    <el-input v-model="form.FName"></el-input>
                </el-form-item>
                <el-form-item label="负责人" prop="FLeader">
                    <sy-select v-model="form.FLeader" valueKey="FID" labelKey = "FName"
                               optionData="server/system/User.ashx?cmd=GetUserOptions">
                    </sy-select>
                </el-form-item>
                  <el-form-item label="备注">
                    <el-input type="textarea" v-model="form.FNote"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
      </el-dialog>
    </div>
</template>

<script>
    import util from '../../common/util'
    export default {
        data() {
            return {
                form: {},
                rules: {
                    FName: [{required: true,message: '项目模板名称', trigger: 'blur'}],
                },
                loading:false,
                editFormVisible:false
            }
        },
        methods: {
            _openEdit(record) {
                this.editFormVisible = true;
                this.form = Object.assign({},record);
               
            },
            _openAdd(record) {
                this.editFormVisible = true;
                this.form = {FID:0};
         
            },
            switchLoading(flag){
                this.loading = flag;
            },
            save:function () {
              
                util.saveForm("server/business/ProjectMould.ashx?cmd=Save",this.$refs.form,this.form,this.switchLoading,result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/ProjectMould_Edit.vue